import React, { useEffect, useState } from "react";
import { HomeIcon } from "@heroicons/react/solid";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  ToastContainer,
  Breadcrumb,
} from "react-bootstrap";
import Select from "react-select";
import {
  useCategoriesByEntMutation,
  useCreateSenderIDMutation,
  useEntByCountryMutation,
} from "Services/services";
import "react-phone-input-2/lib/style.css";
import { Toast } from "react-bootstrap";

// import { UserOnboardingListTable } from "./Tables";
import { Routes } from "routes";
import { useHistory } from "react-router-dom";

export default () => {
  const history = useHistory();
  // Get the user type from localStorage :: UI
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const countryOptions = [
    {
      value: "Saudi Arabia",
      label: "Saudi Arabia (SA)",
    },
    {
      value: "United Arab Emirates",
      label: "United Arab Emirates (AE)",
    },
  ];
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [entOptions, setEntOptions] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [senderId, setSenderId] = useState(null);
  const [files, setFiles] = useState({});

  useEffect(() => {
    if (userType === "enterprise") {
      setSelectedEntity({
        value: userObject.id,
        label: userObject.user_name,
      });
    } else fetchEnterpriseData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  useEffect(() => {
    fetchCatgeoriesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEntity]);

  const handleFileChange = (e) => {
    const { name, files: fileList } = e.target;

    setFiles((prev) => ({
      ...prev,
      [name]: fileList[0],
    }));
  };

  const [entityData] = useEntByCountryMutation();
  const [CategoriesData] = useCategoriesByEntMutation();
  const [create] = useCreateSenderIDMutation();

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const [selectErrors, setSelectErrors] = useState({
    country: false,
    category: false,
    enterprise: false,
    sender: false,
  });
  const [validated, setValidated] = useState(false);

  const fetchEnterpriseData = async () => {
    try {
      const response = await entityData({
        country: selectedCountry.value || "",
      });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.items?.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        // Add a default "Select CRM" option at the beginning of the options array
        setEntOptions([
          ...options,
        ]);
      } else {
        setEntOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setEntOptions([]);
      console.error("Error fetching user data", error);
    }
  };

  const fetchCatgeoriesData = async () => {
    try {
      const response = await CategoriesData({
        country: selectedCountry.value || "",
        user_id: selectedEntity.value,
        has_registered_by_super_admin:
          userType === "super_admin" || userType === "admin",
      });
      if (response?.data) {
        const options = response.data.categories?.map((category) => ({
          value: category,
          label:
            category.charAt(0).toUpperCase() + category.slice(1).toLowerCase(),
        }));
        // Add a default "Select CRM" option at the beginning of the options array
        setCategoryOptions([
          ...options,
        ]);
      } else {
        setCategoryOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setCategoryOptions([]);
      console.error("Error fetching user data", error);
    }
  };

  // SUBMIT
  const submitForm = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    // Validate react-select separately
    const isCountryValid = !!selectedCountry;
    const isCategoryValid = !!selectedCategory;
    const isEntityValid = userType === "enterprise" || !!selectedEntity;
    const regex = selectedCountry?.value === "Saudi Arabia"
                              ? /^[a-zA-Z0-9_.,&-]+$/
                              : /^[a-zA-Z0-9]+$/;
    const isSenderValid =
      !!senderId &&
      regex.test(senderId) &&
      !/^[0-9]+$/.test(senderId);

    // console.log("check", !!user, user, isUserValid)
    const isFormValid = form.checkValidity();

    let updatedSender = null;

    if (
      isCountryValid &&
      isCategoryValid &&
      isEntityValid &&
      isSenderValid &&
      isFormValid
    ) {
      if (selectedCategory?.value === "PROMOTIONAL") {
        if (selectedCountry?.value === "Saudi Arabia") {
          updatedSender = senderId + "-AD";
        } else if (selectedCountry?.value === "United Arab Emirates") {
          updatedSender = "AD-" + senderId;
        }
      } else {
        updatedSender = senderId;
      }

      const myFormData = new FormData();
      myFormData.append("country", selectedCountry?.value);
      myFormData.append("category", selectedCategory?.value);
      myFormData.append("sender_id", updatedSender);
      myFormData.append(
        "has_registered_by_super_admin",
        userType === "super_admin" || userType === "admin"
      );
      myFormData.append("user_id", selectedEntity.value);
      myFormData.append("user_name", selectedEntity.label);
        selectedCountry?.value === "Saudi Arabia"
          ? myFormData.append("company_registration", files.companyReg)
          : myFormData.append("trade_licence", files.companyReg);
   
        selectedCountry?.value === "Saudi Arabia"
          ? myFormData.append("delegation_letter", files.delegationLetter)
          : myFormData.append("noc_doc", files.delegationLetter);
      
      myFormData.append("trademark_doc", files.trademark || null);

      // myFormData.forEach((value, key) => {
      //   console.log(`${key}:`, value);
      // });

      create(myFormData)
        .then((success) => {
          if (success?.data?.statusCode === 201) {
            setToastMessage(success?.data?.message);
            setToastVariant("success");
            setTimeout(() => {
              history.push(Routes.SenderIDRegistration.path);
            }, 2000);
          } else if (success?.data?.statusCode > 300) {
            setToastMessage(
              `Error: ${success?.data?.message || "Upload failed!"}`
            );
            setToastVariant("danger");
          }
          setShowToast(true);
        })
        .catch((error) => {
          console.error("Upload failed", error);
          setToastMessage(`Error: ${error?.message || "Upload failed!"}`);
          setToastVariant("danger");
          setShowToast(true);
        });
    } else {
      setSelectErrors({
        country: !isCountryValid,
        category: !isCategoryValid,
        enterprise: !isEntityValid,
        sender: !isSenderValid,
      });
    }

    setValidated(true);
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <h5 className="mb-4">General information</h5>
          <Form
            noValidate
            validated={validated}
            onSubmit={submitForm}
            autoComplete="off"
          >
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />
            <Row>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="country">
                  <RequiredLabel label="Select Country" />
                  <Select
                    options={countryOptions}
                    placeholder="Select Country"
                    className="mb-0"
                    isSearchable={true}
                    value={selectedCountry}
                    onChange={(selectedOption) => {
                      setSelectedCountry(selectedOption);
                      setSelectedEntity(null)
                      setSelectedCategory(null)
                      setSenderId('')
                      setSelectErrors((prev) => ({
                        ...prev,
                        country: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && selectErrors.country ? '#dc3545' : validated && !selectErrors.country && selectedCountry ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {selectErrors.country && (
                    <div className="invalid-feedback d-block">
                      Country selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              {userType !== "enterprise" && (
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="enterprise">
                    <RequiredLabel label="Select Enterprise" />
                    <Select
                      options={entOptions}
                      placeholder="Select User"
                      className="mb-0"
                      isSearchable={true}
                      value={selectedEntity}
                      onChange={(selectedOption) => {
                        setSelectedEntity(selectedOption);
                        setSelectedCategory(null)
                        setSenderId('')
                        setSelectErrors((prev) => ({
                          ...prev,
                          enterprise: false,
                        }));
                      }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          borderColor: validated && selectErrors.enterprise ? '#dc3545' : validated && !selectErrors.enterprise && selectedEntity ? '#65BB82': provided.borderColor,
                          borderRadius: '0.75rem',
                        }),
                      }}
                    />
                    {selectErrors.enterprise && (
                      <div className="invalid-feedback d-block">
                        Enterprise selection is required.
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="category">
                  <RequiredLabel label="Select Category" />
                  <Select
                    options={categoryOptions}
                    placeholder="Select Category"
                    className="mb-0"
                    isSearchable={true}
                    value={selectedCategory}
                    onChange={(selectedOption) => {
                      setSelectedCategory(selectedOption);
                      setSenderId("");
                      setSelectErrors((prev) => ({
                        ...prev,
                        category: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && selectErrors.category ? '#dc3545' : validated && !selectErrors.category && selectedCategory ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {selectErrors.category && (
                    <div className="invalid-feedback d-block">
                      Category selection is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="sender">
                  <RequiredLabel label="Sender-ID" />
                  {(selectedCategory?.value === "ADVERTISEMENT" || selectedCategory?.value === "PROMOTIONAL") ? (
                    <div className="d-flex">
                      {selectedCountry?.value === "United Arab Emirates" && (
                        <Form.Control
                          disabled
                          type="text"
                          className="mb-0 me-2"
                          value={"AD-"}
                          style={{ width: "60px" }}
                        />
                      )}
                     <Form.Control
                        required
                        type="text"
                        placeholder="Sender-ID"
                        className="mb-0"
                        value={senderId}
                        maxLength={8}
                        minLength={3}
                        pattern={
                          selectedCountry?.value === "Saudi Arabia"
                            ? "^[a-zA-Z0-9_.,&-]+$"
                            : "^[a-zA-Z0-9]+$"
                        }
                        title="Sender ID must be alphanumeric with 3-8 characters, not all numbers. Saudi Arabia allows _, ., ,, &, -."
                        onChange={(e) => {
                          const val = e.target.value;
                          setSenderId(val);
                        
                          // use the same valid regex used in `pattern`
                          const regex =
                            selectedCountry?.value === "Saudi Arabia"
                              ? /^[a-zA-Z0-9_.,&-]+$/
                              : /^[a-zA-Z0-9]+$/;
                        
                          const isAlphanumeric = regex.test(val);
                        
                          setSelectErrors((prev) => ({
                            ...prev,
                            sender: val === "" || isAlphanumeric ? false : true,
                          }));
                        }}
                        autoComplete="off"
                      />

                      {selectedCountry?.value === "Saudi Arabia" && (
                        <Form.Control
                          disabled
                          type="text"
                          className="mb-0 ms-2"
                          value={"-AD"}
                          style={{ width: "60px" }}
                        />
                      )}
                    </div>
                  ) :  (
                     <Form.Control
                        required
                        type="text"
                        placeholder="Sender-ID"
                        className="mb-0"
                        value={senderId}
                        maxLength={11}
                        minLength={3}
                        pattern={selectedCountry?.value === "Saudi Arabia"?'^[-_.,&a-zA-Z0-9]+$':'^[a-zA-Z0-9]+$'}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSenderId(val);

                          const regex =
                          selectedCountry?.value === "Saudi Arabia"
                            ? /^[a-zA-Z0-9_.,&-]+$/
                            : /^[a-zA-Z0-9]+$/;
                      
                        const isAlphanumeric = regex.test(val);
                      
                        setSelectErrors((prev) => ({
                          ...prev,
                          sender: val === "" || isAlphanumeric ? false : true,
                        }));
                        }}
                        title="Sender ID must be alphanumeric with 3-11 characters, not all numbers. Saudi Arabia allows _, ., ,, &, -."
                        autoComplete="off"
                      />
                    )}
                  {selectErrors.sender && (
                    <div className="invalid-feedback d-block">
                        Enter a valid Sender-ID.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="companyReg">
                  <RequiredLabel
                    label={
                      selectedCountry?.value === "Saudi Arabia"
                        ? "Company Registration"
                        : "Trade License"
                    }
                  />
                  <Form.Control
                    required
                    type="file"
                    name="companyReg"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      const maxSize = 2 * 1024 * 1024; // 2MB

                      if (file) {
                        if (file.size > maxSize) {
                          setToastMessage("File size should not exceed 2MB");
                          setToastVariant("danger");
                          setShowToast(true);
                          e.target.value = ""; // clear the input
                          return;
                        }
                        handleFileChange(e);
                      }
                    }}
                    accept=".pdf,.doc,.docx,.xml"
                  />
                  <Form.Control.Feedback type="invalid">
                    Company Registration is required.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="delegationLetter">
                  <RequiredLabel
                    label={
                      selectedCountry?.value === "Saudi Arabia"
                        ? "Delegation Letter"
                        : "NOC"
                    }
                  />
                  <Form.Control
                    required
                    type="file"
                    name="delegationLetter"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      const maxSize = 2 * 1024 * 1024; // 2MB

                      if (file) {
                        if (file.size > maxSize) {
                          setToastMessage("File size should not exceed 2MB");
                          setToastVariant("danger");
                          setShowToast(true);
                          e.target.value = ""; // clear the input
                          return;
                        }
                        handleFileChange(e);
                      }
                    }}
                    accept=".pdf,.doc,.docx,.xml"
                  />
                  <Form.Control.Feedback type="invalid">
                    Delegation Letter is required.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="trademark">
                  <Form.Label>Trademark</Form.Label>
                  <Form.Control
                    type="file"
                    name="trademark"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      const maxSize = 2 * 1024 * 1024; // 2MB

                      if (file) {
                        // console.log("Selected file size (bytes):", file.size); // For debugging
                        if (file.size > maxSize) {
                          setToastMessage("File size should not exceed 2MB");
                          setToastVariant("danger");
                          setShowToast(true);
                          e.target.value = ""; // clear the input
                          return;
                        }
                        handleFileChange(e);
                      }
                    }}
                    accept=".pdf,.doc,.docx,.xml"
                  />
                </Form.Group>
              </Col>
            </Row>

          <div className="d-flex justify-content-end">
            <Button
              variant="secondary"
              className="mt-2 animate-up-2"
              type="submit"
            >
              Submit
            </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
